import React from 'react';
import { BannerPosition } from 'AdminNotificationService/createAdminNotificationClient';
import { GenericErrorBoundary } from 'App/GenericErrorBoundary';
import {
	AdminNotificationBanner,
	DevicePostureBanner,
	useDevicePostureDetails,
} from 'Components/AppLayout';
import { environment } from 'Environment';
import { isNativeWidget } from 'Environment/launchResource/device';

const _AppHeader = () => {
	const { devicePosture, shouldShowDevicePostureBanner } = useDevicePostureDetails();

	return (
		<>
			{shouldShowDevicePostureBanner && (
				<DevicePostureBanner
					intendedPosition={BannerPosition.Top}
					transactionId={devicePosture?.scanTransactionId}
				/>
			)}
			{environment.citrixCloudConnected && !isNativeWidget() && (
				<AdminNotificationBanner intendedPosition={BannerPosition.Top} />
			)}
		</>
	);
};

export const AppHeader = () => {
	return <GenericErrorBoundary renderProp={() => <_AppHeader />} name="AppHeaderError" />;
};
